import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    imports: [
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatChipsModule,
        MatOptionModule,
        MatGridListModule,
        MatProgressBarModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDialogModule,
        MatSnackBarModule,
        MatSelectModule,
        MatInputModule,
        MatSidenavModule,
        MatCardModule,
        MatIconModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatListModule,
        MatTooltipModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRippleModule,
        MatAutocompleteModule,
        MatTableModule,
        MatSortModule
    ],
    exports: [
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatChipsModule,
        MatOptionModule,
        MatGridListModule,
        MatProgressBarModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatMenuModule,
        MatDialogModule,
        MatSnackBarModule,
        MatSelectModule,
        MatInputModule,
        MatSidenavModule,
        MatCardModule,
        MatIconModule,
        MatRadioModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatListModule,
        MatTooltipModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRippleModule,
        MatAutocompleteModule,
        MatTableModule,
        MatSortModule
    ],
})
export class AppMaterialModule { }
